import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import {
	createRoutesFromChildren,
	matchRoutes,
	useLocation,
	useNavigationType,
} from "react-router-dom";
import { Replay } from "@mui/icons-material";

Sentry.init({
	environment: import.meta.env.VITE_APP_ENV || import.meta.env.MODE,
	dsn: import.meta.env.VITE_SENTRY_DSN,
	integrations: [
		// See docs for support of different versions of variation of react router
		// https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
		Sentry.reactRouterV6BrowserTracingIntegration({
			useEffect,
			useLocation,
			useNavigationType,
			createRoutesFromChildren,
			matchRoutes,
		}),
		Sentry.replayIntegration({ workerUrl: "/assets/worker.min.js" }),
		Sentry.feedbackIntegration({
			autoInject: false,
			themeLight: {
				background: "#ffffff",
			},
			showBranding: false,
			themeDark: {
				background: "#222222",
			},
			// Additional SDK configuration goes in here, for example:
			// colorScheme: "system",
		}),
	],
	maxBreadcrumbs: 50,
	debug: import.meta.env.MODE === "production" ? false : true,
	// Set tracesSampleRate to 1.0 to capture 100%
	// of transactions for tracing.
	// Learn more at
	// https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
	tracesSampleRate: 1.0,

	// Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
	tracePropagationTargets: [
		/^https:\/\/api\.dev\.elifeinsure\.com\.au\/term\/dev\/life/,
		/^https:\/\/api\.elifeinsure\.com\.au\/term\/v1\/life/,
	],

	// Capture Replay for 10% of all sessions,
	// plus for 100% of sessions with an error
	// Learn more at
	// https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,
});
